import React from "react";
import "./app.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Container } from "./components/container/container";
import { RecoilRoot } from "recoil";

const App = () => {
    return (
        <Router>
            <RecoilRoot>
                <Switch>
                    {/* <Route path="/kaart">
                        <Container></Container>
                    </Route> */}
                    <Route path="/video/:company?">
                        <Container></Container>
                    </Route>
                    <Route path="/virtual-tour/:tour/:panorama?">
                        <Container></Container>
                    </Route>
                    <Route path="/embed/virtual-tour/:tour/:panorama?">
                        <Container isEmbed={true}></Container>
                    </Route>
                </Switch>
            </RecoilRoot>
        </Router>
    );
};

export default App;
